export enum DocumentProcessStatus {
  NOT_UPLOADED = 'NOT_UPLOADED', // Before S3 presigned url is used
  DOCUMENT_TYPE_VALIDATION_FAILED = 'DOCUMENT_TYPE_VALIDATION_FAILED',
  DOCUMENT_TYPE_VALIDATION_COMPLETED = 'DOCUMENT_TYPE_VALIDATION_COMPLETED',
  DOCUMENT_DATA_EXTRACTION_FAILED = 'DOCUMENT_DATA_EXTRACTION_FAILED',
  DOCUMENT_DATA_EXTRACTION_COMPLETED = 'DOCUMENT_DATA_EXTRACTION_COMPLETED',
  UPLOADED_NOT_PROCESSED = 'UPLOADED_NOT_PROCESSED', // AI is not enabled
  UPLOADED_AI_SERVICE_UNAVAILABLE = 'UPLOADED_AI_SERVICE_UNAVAILABLE', // AI processing failed
  EXAM_VERIFICATION_FAILED = 'EXAM_VERIFICATION_FAILED', // Exam verification failed
  EXAM_VERIFICATION_COMPLETED = 'EXAM_VERIFICATION_COMPLETED', // Exam verification completed
  EXAM_VERIFICATION_MISMATCH = 'EXAM_VERIFICATION_MISMATCH', // Exam verification mismatch
}

export enum ConfidenceLevel {
  HIGH = 'high',
  LOW = 'low',
  MISMATCH = 'mismatch',
}

export type ValueWithConfidence<T> = {
  value: T;
  confidence: ConfidenceLevel;
};

export type ISO8601Date = string;
